import api from "./axiosInstance";
import networkConfig from "../utils/networkConfig";

export const getAdminProfile = async () => {
  const res = await api.get(networkConfig.auth.profile);
  return res.data;
};

export const updateAdminProfile = async (data) => {
  const res = await api.put(networkConfig.auth.profile, data);
  return res.data;
};

export const changeAdminPassword = async (data) => {
  const res = api.put(networkConfig.auth.updatePassword, data);
  return res.data;
};

export const updateAdminProfilePicture = (formData) => {
  const res = api.put(networkConfig.auth.updateProfilePic, formData);
  return res.data;
};
